import React, { useState } from "react";
import { useSelector } from "react-redux";
import CrossGrayIcon from "../../common/images-new/cross-gray-icon.svg";
import { Card } from "../Theme";
import { BiSolidHourglass } from "react-icons/bi";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function TaskModal({ onClose, show, title, task }) {
  const [todos, setTodos] = useState(task);

  const handleChange = (id) => {
    // const updatedTodos = todos?.map((todo) => {
    //   if (todo.id === id) {
    //     todo.response_type = !todo.response_type;
    //   }
    //   return todo
    // });
    // setTodos(updatedTodos);
  };

  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);
  const userTheme = useSelector((state) => state.auth.theme);

  if (!show) return null;

  return (
    <div className="fixed z-50 top-0 bottom-0 left-0 right-0 bg-filter flex items-center justify-center">
      <Card
        className="relative md:w-2/5  py-3 px-6 shadow-xl rounded-md justify-self-end overflow-y-auto bg-white"
        onClick={(e) => e.stopPropagation()}
      >
        {/* <p className='text-lg font-semibold mb-4'>{title}</p> */}
        <p className="text-center font-bold text-xl pt-1">{title}</p>
        <img
          className="absolute right-4 md:right-8 top-6 cursor-pointer hover:opacity-60"
          onClick={onClose}
          alt="cross"
          src={CrossGrayIcon}
        />
        <hr className="mt-3 border-gray-200" />
        <p className="mt-3 text-center font-semibold mb-4">All Tasks</p>
        {task.length > 0 &&
          task.map((list, index) => (
            <div key={index} className="flex mb-3 justify-start items-center">
              <div className="">
                {/* {isDefaultTheme == false ?
                <label class="container-check">
                  <input type="checkbox" checked={list.response_status || false} readOnly={true} />
                  <span class="checkmark" onClick={(e) => e.stopPropagation()}></span>
                </label>
                :
                <>
                  <input
                    type="checkbox" className="opacity-0 absolute h-4 w-4 lg:h-6 lg:w-6 cursor-pointer"
                    checked={list.response_status || false} 
                    onClick={(e) => e.stopPropagation()}
                    readOnly={true}
                  />
                  <div className='box bg-gray border rounded border-gray-400 h-4 w-4 lg:w-6 lg:h-6 flex justify-center items-center'>
                    <svg className="mark fill-current hidden w-4 h-4 text-white pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z" /></svg>
                  </div></>} */}
                {list.response_status ? (
                  <CheckCircleIcon
                    style={{
                      color:
                        userTheme == "" || userTheme == "default theme"
                          ? "#66D692"
                          : userTheme?.color2,
                    }}
                  />
                ) : (
                  <CheckCircleIcon
                    className="secondaryIcon flex-shrink-0"
                  // style={{ fontSize: "18px" }}
                  />
                )}
              </div>
              <div
                className=" px-2 "
                onClick={(event) => event.preventDefault()}
              >
                {list.task_name}
              </div>
            </div>
          ))}
      </Card>
    </div>
  );
}
